import React, { Fragment } from 'react'

import { IconS24Building224 } from '@is24/cosma-ui-icons'
import { InsertionFlowScreensProps } from '../../../../../@types/props-types'
import { SCREEN_OBJECT_DETAILS, SCREENS } from '../../../../../services/domain/wizardScreens'
import { ObjectDetailsScreenValidationResult } from '../../../../../@types/validation-types'
import ScreenContainer from '../../../../common/containers/screenContainer/ScreenContainer'
import { FieldProps } from '../../../../../@types/types'
import { ScreenLayout } from '../../../../common/containers/screenLayout/ScreenLayout'
import { isWebView } from '../../../../../utils/navigation'
import { RequiredWBSField } from './RequiredWBSField'

const screen = SCREENS[SCREEN_OBJECT_DETAILS]
export type ObjectDetailsWrapperProps = FieldProps<ObjectDetailsScreenValidationResult>

export type ObjectDetailsAdditionalProps = {
  headerKey?: string
  screenTooltipKey?: string
  properties: ((objectDetailsWrapperProps: ObjectDetailsWrapperProps) => JSX.Element)[]
  displayRequiredWBSField?: boolean
}

export const ObjectDetails: React.FC<
  InsertionFlowScreensProps<ObjectDetailsScreenValidationResult> & ObjectDetailsAdditionalProps
> = ({
  flowInformation,
  insertionData,
  validationMessages,
  properties,
  onChange,
  doReset,
  onNavigate,
  headerKey = 'wizard.screen.objectDetails.header',
  displayRequiredWBSField = false,
}) => {
  const isMobile = isWebView()

  const wrapperProps: ObjectDetailsWrapperProps = {
    flowInformation: flowInformation,
    validationMessages: validationMessages,
    insertionData: insertionData,
    screenName: screen.name,
    screenId: screen.id,
    doReset: doReset,
    onChange: onChange,
  }

  return (
    <ScreenContainer
      className={isMobile ? 'margin-bottom-xxl' : ''}
      disableMarginBottom={isMobile}
      containerId={screen.id}
      onNavigate={onNavigate}
      screen={screen}
    >
      <ScreenLayout
        id={`${screen.id}`}
        headline={headerKey}
        className='grid grid-flex gutter-vertical-l'
        headerIcon={<IconS24Building224 />}
        screenName={screen.name}
      >
        {properties.map((item, index) => (
          <Fragment key={index}>{item(wrapperProps)}</Fragment>
        ))}
        {displayRequiredWBSField && <RequiredWBSField {...wrapperProps} />}
      </ScreenLayout>
    </ScreenContainer>
  )
}
